export const spaceCadet = {
  100: '#F3F4F6',
  300: '#D0D5DC',
  400: '#728096',
  500: '#142B50',
  600: '#102240',
  700: '#0C1A30',
  800: '#040910',
};

export const ultraMarine = {
  100: '#F2F7FF',
  300: '#CCE0FF',
  400: '#66A1FF',
  500: '#0062FF',
  600: '#004ECC',
  700: '#003B99',
  800: '#001433',
};

export const chromeYellow = {
  100: '#FFFBF2',
  200: '#FFEECC',
  300: '#FFEECC',
  400: '#FFCD66',
  500: '#FFAB00',
  600: '#CC8900',
  700: '#996700',
  800: '#332200',
};

export const sanguine = {
  100: '#FFF2F6',
  200: '#FFCCDB',
  300: '#FFCCDB',
  400: '#FF6694',
  500: '#FF004D',
  600: '#CC003D',
  700: '#99002E',
  800: '#33000F',
};

export const kiwiGreen = {
  100: '#F4FDF7',
  300: '#D4F9DE',
  400: '#7EEE9D',
  500: '#28E25C',
  600: '#20B549',
  700: '#188837',
  800: '#082D12',
};

export const salmon = {
  100: '#FFFDFC',
  200: '#FFFAF9',
  300: '#FFEBE8',
  400: '#FFC2BB',
  500: '#FF9A8D',
  600: '#995C55',
  700: '#331F1C',
  800: '#0D0807',
};

export const orange = {
  100: '#FFFDFB',
  200: '#FEFAF6',
  300: '#FDEDDA',
  400: '#F9C991',
  500: '#F4A547',
  600: '#93632B',
  700: '#31210E',
  800: '#0C0804',
};

export const purple = {
  100: '#FAF7FF',
  200: '#F6F0FF',
  300: '#ECE0FF',
  400: '#C6A3FF',
  500: '#A066FF',
  600: '#603D99',
  700: '#201433',
  800: '#100A19',
};

export const cyan = {
  100: '#F8FDFE',
  200: '#F3FBFD',
  300: '#E7F3F7',
  400: '#B8DCE8',
  500: '#89C5D8',
  600: '#527682',
  700: '#1B272B',
  800: '#0E1416',
};

export const aqua = {
  100: '#F8FCFE',
  200: '#F2FBFE',
  300: '#E3F5FB',
  400: '#ADE2F3',
  500: '#76CFEB',
  600: '#477C8D',
  700: '#17292F',
  800: '#0C1518',
};
